<template>
  <span
    :class="[
      'px-2 py-1 text-xs font-medium rounded-full text-white',
      value ? 'bg-green-500' : 'bg-gray-500'
    ]"
  >
    {{ value ? yes : no }}
  </span>
</template>

<script>
export default {
  name: "OPFormalLabel",
  props: {
    value: {
      default: true
    },
    yes: {
      default: "Formalizado"
    },
    no: {
      default: "No formalizado"
    }
  }
};
</script>
